import React from 'react';
import './Btn.css';
import { Link } from 'react-router-dom';

const Btn = (props) => {
    if (props.BtnPath) {
        return (
            <Link to={props.BtnPath} className={props.LinkClass}>
                <button type="button" className={props.BtnStyle} onClick={props.onClick}>
                    <p>{props.BtnText}</p>
                </button>
            </Link>
        );
    }

    return (
        <button 
            type={props.type || "button"} 
            className={props.BtnStyle} 
            onClick={props.onClick}
        >
            <p>{props.BtnText}</p>
        </button>
    );
}

export default Btn;